<main>
<div class="hide-acc">
  <div class="container-box cart-page">
    <div class="row">
      <div class="col-sm-12 col-md-10 col-md-offset-1">
        <div class="error-container" aria-live="assertive">
          <div class="alert valign-children-middle mar-top-20" *ngIf="checkOutErrorMessage">
            <div class="alert-error" aria-label="Alert.">
              <i class="icon-badgealert" aria-hidden="true"></i>
            </div>
            <div aria-labelledby="ErrorSection">
              <h2 id="ErrorSection">Error!</h2>
              <p>{{ this.checkOutErrorMessage }}</p>
            </div>
          </div>
        </div>
        <div *ngIf="this.cart && this.cart != null && this.cart.lineItems && this.cart.lineItems.length > 0" [attr.aria-label]="cartHeader">
          <h1> {{cartHeader}}<small class="clear-cart pull-right"> <a href="javascript:void(0)" aria-label="Empty Cart - opens a dialog box" (click)="showEmptyCartModal($event)"> Empty cart </a> </small></h1>
          <h2>Review order </h2>
          <!-- Contractual and list price description-->
          <div *ngFor="let cartitem of this.cart.lineItems;let i = index">
          <p *ngIf = "this.cart.lineItems.length == 1 && this.cart && this.cart.lineItems[i].maxQty > 1">You might qualify for contractual pricing, a volume discount, or both. These will be applied to your total charges
            after you select your wireless number during checkout.</p>
		  <p *ngIf = "this.cart && this.cart.lineItems[i].maxQty == 1 && this.cart.lineItems.length == 1">If you qualify for discounts, your total will be updated during checkout.</p>  
          </div>
		  
          
	 	<p *ngIf = "this.cart.lineItems.length > 1">You might qualify for contractual pricing, a volume discount, or both. These will be applied to your total charges
            after you select your wireless number during checkout.</p> 
          
          <div role="grid">
            <h3 role="row"> <span role="columnheader"> Product</span> <span class="pull-right" role="columnheader"> Amount </span> </h3>
            <hr/>
            <form [formGroup]="cartForm" role="row" autocomplete="off">
              <div formArrayName="cartItems">
                <!-- Iteration Starts -->
                <div *ngFor="let cartitem of this.cart.lineItems;let i = index">
                  <div [formGroupName]="i">
                    <div class="product-details">
                      <div class="row">
                        <div class="col-sm-8 col-md-12">
                          <p class="display-name">{{cartitem.displayName}} {{+' - '+cartitem.sku.skuType}}</p>
                          <p> <strong>Monthly charges </strong> </p>
                        </div>
                        <div class="col-sm-8 col-md-6" *ngIf = "this.cart && this.cart.lineItems[i].maxQty > 1">
                          <p>License price of {{cartitem.sku.priceInfo.monthlyRecurringFee.amount|currency:'USD':true:'1.2-3'}}/user
                            </p>
                        </div>
                        <!-- <div class="col-sm-4 col-md-6 text-right">
                      <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount !== 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}} </p>
                      <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount === 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}} </p>
                      <small> Per month </small>
                    </div> -->
                      </div>
                      <div class="row"  >
                        <div class="col-sm-12 col-md-12">
                          <div class="row">
						   <span *ngIf = "this.cart && this.cart.lineItems[i].maxQty > 1" >
                            <label class="col-sm-12 col-md-12 label-block" [ngClass]="{'error-field': formErrors[i].quantity}" [attr.for]="'inputLicense'+i">Number of licenses </label>                            <br>
                            <div class="col-sm-7 col-md-2">
                              <input id="{{'inputLicense'+i}}" [attr.aria-describedby]="formErrors[i].quantity? 'cart-qty-error'+i : null" class="form-control"
                                [class.text-error]="formErrors[i].quantity" formControlName="quantity" type="text" />
                            </div>
                            <div *ngIf="formErrors[i].quantity" class="show-sm text-danger qty-error" tabindex="0">{{ formErrors[i].quantity }}</div>
                            <div class="col-sm-7 col-md-2">
                              <button type="button" class="btn btn-secondary btn-update" (click)="updatePrice(i,formErrors[i].quantity)" [disabled]="formErrors[i] && formErrors[i].quantity.length > 0"
                                aria-label="Update number of licenses."> Update </button>
                            </div>
							</span>
							<div class="col-sm-7 col-md-6" *ngIf = "this.cart && this.cart.lineItems[i].maxQty == 1">
							  <p >License Price (Unlimited Users)
								</p>
							</div>
                            <div class="col-sm-5 col-md-6 text-right" *ngIf = "this.cart && this.cart.lineItems[i].maxQty == 1">
                              <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount !== 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}}
                                </p>
                              <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount === 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}}
                                </p>
                              <small> per month </small>
                            </div>
							<div class="col-sm-5 col-md-8 text-right " *ngIf = "this.cart && this.cart.lineItems[i].maxQty > 1">
                              <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount !== 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}}
                                </p>
                              <p class="price-value" *ngIf='cartitem && cartitem.priceInfo.monthlyRecurringFee.amount === 0'> {{cartitem && cartitem.priceInfo.monthlyRecurringFee.amount| currency:'USD':true:'1.2-3'}}
                                </p>
                              <small> per month </small>
                            </div>
                            <div *ngIf="formErrors[i].quantity" id="{{'cart-qty-error'+i}}" class="hide-sm text-danger qty-error">{{ formErrors[i].quantity }}</div>
                          </div>
                        </div>
                      </div>
                      <!-- Iteration Starts -->
                      <div class="subproduct-details mar-top-20" *ngIf="cartitem.sku.priceInfo.oneTimeFee && cartitem.sku.priceInfo.oneTimeFee.length > 0">
                        <div class="row">
                          <div class="col-sm-8 col-md-8">
                            <p> <strong>One-time charges </strong> </p>
                          </div>
                        </div>
                        <div *ngFor="let onetimefee of cartitem.sku.priceInfo.oneTimeFee">
                          <div class="row">
                            <div class="col-sm-6 col-md-6">
                              <p class="onetime-charges">{{onetimefee.oneTimeFeeName}}</p>
                              <small></small>
                            </div>
                            <div class="col-sm-6 col-md-3 text-right">
                              <p class="price-value" *ngIf='onetimefee.unitPrice !== 0'>{{onetimefee.unitPrice | currency:'USD':true:'1.2-3' }} </p>
                              <p class="price-value" *ngIf='onetimefee.unitPrice === 0'>{{onetimefee.unitPrice | currency:'USD':true:'1.2-3' }} </p>
                              <small> one-time charge </small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Iteration Ends -->
                      <div class="row">
                        <div class="col-sm-7 col-md-4">
                          <hr class="hr-top" />
                          <p class="cart-links"> <a href="javascript:void(0)" (click)="gotoChangeConfigurator(i)" attr.aria-label="Change {{ cartitem.displayName }} from cart."> Change selected package </a></p>
                          <p class="cart-links"> <a href="javascript:void(0)" (click)="showDeleteItemModal(i,$event, cartitem.displayName)" attr.aria-label="Remove {{ cartitem.displayName }} from cart - opens a dialog box"> Remove from cart </a>                            </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr/>
                </div>
                <!-- Iteration Ends -->
              </div>
            </form>
            <div class="product-details" role="row">
              <h2> Total charges* </h2>
              <div class="row" role="row">
                <div class="col-sm-8 col-md-6" role="gridcell">
                  <p> Total one-time charge</p>
                </div>
                <div class="col-sm-4 col-md-3 text-right" role="gridcell">
                  <p class="total-price" *ngIf='this.cart.priceInfo && this.cart.priceInfo.oneTimeFee.amount != 0'> {{this.cart.priceInfo && this.cart.priceInfo.oneTimeFee.amount | currency:'USD':true:'1.2-3'}}</p>
                  <p class="total-price" *ngIf='this.cart.priceInfo && this.cart.priceInfo.oneTimeFee.amount === 0'> {{this.cart.priceInfo && this.cart.priceInfo.oneTimeFee.amount | currency:'USD':true:'1.2-3'}}</p>
                </div>
              </div>
              <div class="row" role="row">
                <div class="col-sm-8 col-md-6" role="gridcell">
                  <p> Total monthly charges </p>
                </div>
                <div class="col-sm-4 col-md-6 text-right" role="gridcell">
                  <p class="total-price" *ngIf='this.cart.priceInfo && this.cart.priceInfo.monthlyRecurringFee.amount != 0'> {{this.cart.priceInfo && this.cart.priceInfo.monthlyRecurringFee.amount | currency:'USD':true:'1.2-3'}}</p>
                  <p class="total-price" *ngIf='this.cart.priceInfo && this.cart.priceInfo.monthlyRecurringFee.amount === 0'> {{this.cart.priceInfo && this.cart.priceInfo.monthlyRecurringFee.amount | currency:'USD':true:'1.2-3'}}</p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <!--<p> <small>* All prices exclude applicable taxes, fees and surcharges </small> </p>-->
          <p> <small>* Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.</small></p>
          <hr class="checkout-spacing hide-sm" />
          <div class="checkout-area text-right">
            <button class="btn btn-success btn-checkout pull-right" (click)="checkout()" [disabled]="(!cartForm.valid || !isFormValid)"
              aria-label="Check out."> Checkout </button>
            <a href="javascript:void(0)" class="btn btn-link btn-shopping" (click)="gotoBrowse()"> Continue shopping </a>
          </div>
          <hr class="checkout-spacing hide-sm " />
          <!--<p> <small> Legal copy goes here. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dictum ante non convallis suscipit. Pellentesque habitant morbi tristique senectus et
            netus et malesuada fames ac turpis egestas. </small> </p> -->
        </div>
        <div *ngIf="!this.cart" aria-labelledby="cartHeaderSection">
          <h1 id="cartHeaderSection"> {{cartHeader}} </h1>
          <p>There are no items in your cart. Browse the app store to add items.</p>
          <hr class="checkout-spacing hide-sm" />
          <div class="checkout-area text-right continue-shopping">
            <a href="javascript:void(0)" role="button" class="btn btn-checkout btn-secondary" (click)="gotoBrowse()" aria-label="Continue shopping."> Continue shopping </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- modal Popup-->

<div *ngIf="flushCart" aria-label="Empty Cart Dialog">
  <app-modal [showModal]="flushCart" [modalClass]="modalClass">
    <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="emptyCart($event)"></app-confirm-modal>
  </app-modal>
</div>
<div *ngIf="deleteItem" aria-label="Delete Product Dialog">
  <app-modal [showModal]="deleteItem" [modalClass]="modalClass">
    <app-confirm-modal [modalPopupObject]='confirmModalPopup' [triggerElement]='eventEmit' (modalOutput)="deleteProduct($event)"></app-confirm-modal>
  </app-modal>
</div>
</main>